////////////////////////////////////////////////Gallery
if (!customElements.get('dl-js-gallery')) {
  // モーダルの生成
  var GalleryHtml = `
  <div class='dl-common__parts'>
    <div class='dl-js-gallery'>
      <div class='dl-js-gallery__wrap'>
        <div class='dl-js-gallery__loading'><span></span></div>
        <dl-js-gallery__close class='dl-js-gallery__close__base'></dl-js-gallery__close>
          <dl-js-gallery__close class='dl-js-gallery__close__head'><span></span></dl-js-gallery__close>
        <div class='dl-js-gallery__content'>
          <div class='dl-js-gallery__content__wrap'>
            <div class='dl-js-gallery__content__body'>
              <img src="/assets/dl-pic-about_a_01.jpg" class="dl-js-gallery__image">
            </div>
            <div class='dl-js-gallery__content__foot'>
              <div class='dl-js-gallery__html'>この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。</div>
              <div class="dl-js-gallery__ctrl">
                <div class="dl-js-gallery__ctrl__wrap">
                  <ul class="dl-js-gallery__ctrl__nav">
                    <li class="dl-js-gallery__ctrl__nav__arrow is-prev"><div><span>前へ</span></div></li>
                    <li class="dl-js-gallery__ctrl__nav__close"><dl-js-gallery__close><span>閉じる</span></dl-js-gallery__close></li>
                    <li class="dl-js-gallery__ctrl__nav__arrow is-next"><div><span>次へ</span></div></li>
                  </ul>
                  <div class="dl-js-gallery__ctrl__num">
                    <span class="dl-js-gallery__ctrl__num__wrap">
                      <span class="dl-js-gallery__ctrl__num__idx">00</span> / <span class="dl-js-gallery__ctrl__num__length">00</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--<dl-js-gallery__close class='dl-js-modal__close__foot'><span><span></span>CLOSE</span></dl-js-modal__close>-->
        </div>
      </div>
    </div>
  </div>
  `;

  document.querySelector('main').insertAdjacentHTML('afterend', GalleryHtml);
  class DL_GalleryClose extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        "click",
        function() {
          document.body.style.overflow = "inherit";
          DL_fadeOut(document.querySelector('.dl-js-gallery'), 300, function() {
            document.querySelector('.dl-js-gallery__content').style.display = "none";
            document.querySelector('.dl-js-gallery__content__foot').style.display = "none";
            document.querySelector('.dl-js-gallery__image').setAttribute("src", "");
            for (var i = 0; i < document.querySelectorAll('dl-js-gallery').length; i++) {
              document.querySelectorAll('dl-js-gallery')[i].reset()
            }
          });
        },
        false
      );

    }
  }

  customElements.define('dl-js-gallery__close', DL_GalleryClose);

  for (var i = 0; i < document.querySelectorAll('.dl-js-gallery__ctrl__nav__arrow').length; i++) {
    document.querySelectorAll('.dl-js-gallery__ctrl__nav__arrow')[i].addEventListener(
      "click",
      function() {
        const arrow = this;
        let gallery = "";
        for (var j = 0; j < document.querySelectorAll('dl-js-gallery').length; j++) {
          if (document.querySelectorAll('dl-js-gallery')[j].openFlg) {
            gallery = document.querySelectorAll('dl-js-gallery')[j];
          }
        }

        if (DL_hasClass(arrow, "is-next")) {
          gallery.next();
        } else {
          gallery.prev();
        }
      },
      false
    );
  }







  class DL_Gallery extends HTMLElement {
    constructor() {
      super();
      const gallery = this;
      gallery.child = gallery.querySelectorAll('dl-js-gallery__open');
      gallery.childLength = gallery.child.length;
      gallery.childIdx = 0;
      gallery.openFlg = false;
      gallery.ctrlFlg = false;

      if (gallery.getAttribute("data-ctrl")) {
        if (JSON.parse(gallery.getAttribute("data-ctrl").toLowerCase())) {
          gallery.ctrlFlg = true;
        }
      }



      for (var i = 0; i < gallery.child.length; i++) {
        gallery.child[i].setAttribute("data-index", i);
        gallery.child[i].addEventListener(
          "click",
          function() {
            gallery.childIdx = this.getAttribute("data-index");
            gallery.open(gallery.childIdx);
          },
          false
        );
      }
      window.addEventListener('resize', gallery.onResize.bind(gallery));
    }

    open(_index) {
      const gallery = this;
      gallery.src = gallery.child[_index].getAttribute("data-src");
      if (gallery.child[_index].querySelector('dl-js-gallery__html')) {
        gallery.html = gallery.child[_index].querySelector('dl-js-gallery__html');
      }

      if (document.querySelector('.dl-js-gallery').style.display != "block") {
        DL_fadeIn(document.querySelector('.dl-js-gallery'), 300, function() {
          document.body.style.overflow = "hidden";
          gallery.set();
        });
      } else {
        DL_fadeOut(document.querySelector('.dl-js-gallery__content'), 300, function() {
          gallery.set();
        });
      }
    }

    set() {
      const gallery = this;
      gallery.newImage = new Image();
      gallery.newImage.src = gallery.src;
      gallery.newImage.onload = function() {
        gallery.setSize();
        document.querySelector('.dl-js-gallery__image').setAttribute("src", gallery.src);
        // console.log(gallery.html)
        if(gallery.html){
          document.querySelector('.dl-js-gallery__html').style.display = "block";
          document.querySelector('.dl-js-gallery__html').innerHTML = gallery.html.innerHTML;
        } else {
          document.querySelector('.dl-js-gallery__html').style.display = "none";
          document.querySelector('.dl-js-gallery__html').innerHTML = "";
        }

        if (gallery.ctrlFlg) {
          document.querySelector('.dl-js-gallery__ctrl').style.display = "block";
          document.querySelector('.dl-js-gallery__ctrl__num__idx').textContent = DL_zeroPadding(Number(gallery.childIdx) + 1, 2);
          document.querySelector('.dl-js-gallery__ctrl__num__length').textContent = DL_zeroPadding(gallery.childLength, 2);
        } else {
          document.querySelector('.dl-js-gallery__ctrl').style.display = "none";
        }

        if(document.querySelector('.dl-js-gallery__ctrl').style.display == "none" && document.querySelector('.dl-js-gallery__html').style.display == "none"){
          document.querySelector('.dl-js-gallery__content__foot').style.display = "none";
        } else {
          document.querySelector('.dl-js-gallery__content__foot').style.display = "block";
        }

        

        if (document.querySelector('.dl-js-gallery__content').style.display != "block") {
          gallery.openFlg = true;
          DL_fadeIn(document.querySelector('.dl-js-gallery__content'), 400);
        }
      };
    }

    setSize() {
      const gallery = this;
      gallery.newImage.ratio = gallery.newImage.width / gallery.newImage.height;
      var windowRatio = window.innerWidth / window.innerHeight;
      document.querySelector('.dl-js-gallery__image').style.height = "auto";
      document.querySelector('.dl-js-gallery__image').style.width = "auto";

      if (DL_media() == "PC") {
        gallery.displayRatio = 0.7;
      } else {
        gallery.displayRatio = 0.9;
      }
      var w, h
      if (windowRatio <= gallery.newImage.ratio) {
        //横長
        w = window.innerWidth * gallery.displayRatio;
        h = w / gallery.newImage.ratio;
        // console.log("window画角に対して横長")
      } else {
        //縦長
        h = window.innerHeight * gallery.displayRatio;
        w = h * gallery.newImage.ratio;
        // console.log("window画角に対して縦長")
      }
      document.querySelector('.dl-js-gallery__image').style.width = w + "px";
      document.querySelector('.dl-js-gallery__image').style.height = h + "px";
      document.querySelector('.dl-js-gallery__content__foot').style.width = w + "px";
    }

    reset() {
      const gallery = this;
      
      gallery.src = null;
      gallery.html = null;
      gallery.newImage = null;
      gallery.openFlg = false;
      document.querySelector('.dl-js-gallery__image').style.width = "auto";
      document.querySelector('.dl-js-gallery__image').style.height = "auto";
      document.querySelector('.dl-js-gallery__content__foot').style.width = "auto";
    }

    next() {
      const gallery = this;
      if (gallery.childIdx < gallery.childLength - 1) {
        gallery.childIdx++;
      } else {
        gallery.childIdx = 0;
      }
      gallery.open(gallery.childIdx);

    }
    prev() {
      const gallery = this;
      if (gallery.childIdx > 0) {
        gallery.childIdx--;
      } else {
        gallery.childIdx = gallery.childLength - 1;
      }
      gallery.open(gallery.childIdx);

    }

    onResize() {
      const gallery = this;
      if (gallery.openFlg) {
        if (gallery.newImage) {
          gallery.setSize();
        }
      }
    }
  }
  customElements.define('dl-js-gallery', DL_Gallery);
}